import React from "react";
import Button from "../components/ResubleComp/Button";
import { AiOutlineCheck, AiFillCaretRight } from "react-icons/ai";

const Mentor = () => {
  return (
    <div className="">
      <div className="flex flex-col">
        <div className="w-full h-screen flex flex-col justify-center items-center bg-gradient-to-r from-emerald-200 to-yellow-300">
          <h3 className="text-center text-4xl font-bold">
            Join in as a problem solver and bring the change
          </h3>
          <p className="p-5 text-xl text-center">
            solve the problems using modern technology and bring quality
            education for all
          </p>
          <div className="flex justify-center mt-10">
            <a href="/problemsolver/signup">
              <button className="px-8 py-4 rounded-md border border-cyan-600 text-white bg-cyan-600 text-xl">
                Join Now
              </button>
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-center items-center p-8 ">
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mb-6 lg:mb-0">
          <img
            src="/images/whoareyou.jpg"
            alt="img"
            className="max-w-[90%] h-[90%]"
          />
        </div>
        <div className="w-full lg:w-1/2 lg:p-8">
          <h3 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            Who you will be?
          </h3>
          <p className="text-lg lg:text-base text-center lg:text-left">
            You will be a person with the ability to solve any conceptual or
            practical problems in a particular academic or career topic. You can
            be a student or a professional in academics or corporate. You will
            be called a "Problem solver"
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row-reverse justify-center items-center p-8">
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mb-6 lg:mb-0">
          <img src="/images/expert.png" alt="img" />
        </div>
        <div className="w-full lg:w-1/2 lg:p-8">
          <h3 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            What you will be obliged to do?
          </h3>
          <p className="text-lg lg:text-base text-center lg:text-left">
            As a problem solver, you will solve conceptual, technical or
            practical problems for the students in a Live one-to-one session.
            The sessions can be in real-time (Instant) or in a pre-scheduled
            mode.
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-center items-center p-8">
        <div className="w-full lg:w-1/2 flex justify-center   mb-6 lg:mb-0">
          <img src="/images/how-work.png" alt="img" />
        </div>
        <div className="w-full lg:w-1/2 lg:p-8">
          <h3 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            How all of It will work?
          </h3>
          <p className="text-lg lg:text-base text-center lg:text-left">
            <ol className="flex flex-col gap-4">
              <li className="flex items-start">
                <span className="text-green-600 mt-1 mr-2">
                  <AiFillCaretRight />
                </span>
                Create your account and then log in. You will then be redirected
                to your dashboard.
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mt-1 mr-2">
                  <AiFillCaretRight />
                </span>
                You will then fill up the application form on your dashboard.
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mt-1 mr-2">
                  <AiFillCaretRight />
                </span>
                After you submit your application form, we will verify and
                notify you regarding your onboarding as a problem solver .
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mt-1 mr-2">
                  <AiFillCaretRight />
                </span>
                After successful verification, your dashboard will be live and
                ready to take live sessions.
              </li>
            </ol>
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row-reverse justify-center items-center p-8">
        <div className="">
          <img src="/images/benefits.png" alt="img" />
        </div>
        <div className="w-full lg:w-1/2 lg:p-8">
          <h3 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            Benefits & Advantages:
          </h3>
          <p className="text-lg lg:text-base text-center lg:text-left">
            <ol className="flex flex-col gap-4">
              <li className="flex items-start">
                <span className="text-green-600 mt-1 mr-2">
                  <AiOutlineCheck />
                </span>
                By solving problems in your domain, you will enhance your
                knowledge .
              </li>

              <li className="flex items-start">
                <span className="text-green-600 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                You can earn the equivalent of a college teacher/ a
                professional. It will depend on how good you are at solving
                problems, how much time you are devoting and how happy the user
                is with you.
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                You are free to work anytime & anywhere.
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                The session price will increase after every ten
                successful sessions.
              </li>
            </ol>
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-center items-center p-8">
        <div className="w-full lg:w-1/2 lg:p-8">
          <img src="/images/morethings.jpg" alt="img" className="" />
        </div>
        <div className="w-full lg:w-1/2 lg:p-8">
          <h3 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            More things for you:
          </h3>
          <p className="text-lg lg:text-base text-center lg:text-left">
            <ol className="flex flex-col gap-4">
              <li className="flex items-start">
                <span className="text-green-500 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                We treat our problem solvers as great teachers who excel at
                providing quality education.
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                We want you to earn as much as possible by solving problems. We
                expect the best possible learning experience for the users.
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2 mt-1">
                  <AiOutlineCheck />
                </span>
                We respect you and your time. We are continuously working to
                enhance your experience with Fynii.
              </li>
            </ol>
          </p>
        </div>
      </div>
      <div className="flex items-center flex-col md:flex-row justify-center mb-5 md:mb-20 gap-5 md:gap-12">
        <a href="/problemsolver/signup">
          <Button className="px-8 py-4 my-4 rounded-md border border-cyan-600 text-white bg-cyan-600 text-xl">
            Join Now
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Mentor;
